import { Input, Accordion } from '@itau-loans-www/components'

import { useAddressForm } from './hooks'

const AddressForm = ({ control, setValue, isValid }) => {
  const { fillForm } = useAddressForm(setValue)

  return (
    <Accordion title="Endereço" initialOpen={!isValid}>
      <Input.Cep
        label="CEP"
        name="zip_code"
        onResult={fillForm}
        control={control}
      />
      <Input.Text
        label="Endereço"
        id="street"
        name="street"
        autoComplete="on"
        control={control}
        validators={{
          rules: {
            validate: {
              onlyLettersAndNumbers: (value) =>
                /^[ a-zA-ZÀ-ÿ0-9\u00f1\u00d1./,-]*$/g.test(value)
            }
          },
          messages: {
            onlyLettersAndNumbers: 'endereço inválido'
          }
        }}
      />
      <Input.Text
        type="tel"
        label="Número"
        id="number"
        name="number"
        autoComplete="on"
        maxLength="5"
        validators={{
          rules: {
            validate: {
              onlyNumbers: (value) => /^[0-9]+$/.test(value)
            }
          },
          messages: {
            onlyNumbers: 'número inválido'
          }
        }}
        control={control}
      />
      <Input.Text
        label="Complemento"
        id="complement"
        name="complement"
        autoComplete="on"
        control={control}
        required={false}
      />
      <Input.Text
        label="Bairro"
        id="neighborhood"
        name="neighborhood"
        autoComplete="on"
        validators={{
          rules: {
            validate: {
              onlyLettersAndNumbers: (value) =>
                /^[ a-zA-ZÀ-ÿ0-9\u00f1\u00d1./,-]*$/g.test(value)
            }
          },
          messages: {
            onlyLettersAndNumbers: 'bairro inválido'
          }
        }}
        control={control}
      />
      <Input.Text
        label="Cidade"
        id="city"
        name="city"
        autoComplete="on"
        control={control}
        validators={{
          rules: {
            validate: {
              onlyLetters: (value) => /^[ a-zA-ZÀ-ÿ\u00f1\u00d1]*$/g.test(value)
            }
          },
          messages: {
            onlyLetters: 'cidade inválida'
          }
        }}
      />
      <Input.Text
        label="Estado"
        id="state"
        name="state"
        autoComplete="on"
        control={control}
        validators={{
          rules: {
            validate: {
              onlyLetters: (value) => /^[ a-zA-ZÀ-ÿ\u00f1\u00d1]*$/g.test(value)
            }
          },
          messages: {
            onlyLetters: 'estado inválido'
          }
        }}
      />
    </Accordion>
  )
}

export default AddressForm
